



import * as React from 'react';
import RelojChecador from '../../../Services/Catalogos/RelojChecador';
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import { MsgInformativo } from '../../../Utils/Toast/msgInformativo';
import { Button, Card, Form, Col, Row } from 'react-bootstrap';
import { BsSearch, BsFileEarmarkExcel } from 'react-icons/bs';
import { DTOReporteFechas } from '../../Catalogos/CatalogosReloj/DTO/DTOReporteFechas';
import { DTOReporteChecadas } from '../../Catalogos/CatalogosReloj/DTO/DTOReporteChecadas';
import { useState, useEffect } from 'react';

// 2. Definimos la interface fuera del componente para mayor limpieza
interface Props {
  fechaInicio: string;
  fechaFin: string;
  triggerBusqueda?: number;
}

// export default function RptTotalHoursSinArchivo  () {
export default function RptTotalHoursSinArchivo({ fechaInicio, fechaFin, triggerBusqueda }: Props) {
  const [inicio, setInicio] = useState<string>(currentDate());
  const [fin, setFin] = useState<string>(currentDate());
  const [filtro, setFiltro] = useState<string>('');
  const [data, setData] = useState<Array<DTOReporteFechas>>([]);
  const [filteredData, setFilteredData] = useState<Array<DTOReporteFechas>>([]);
  const [detalleData, setDetalleData] = useState<Array<DTOReporteChecadas>>([]);
  const [showToast, setShowToast] = useState<boolean>(false);
  const [toastMsg, setToastMsg] = useState<string>('');
  const [toastHeader, setToastHeader] = useState<string>('');
  const [toastColor, setToastColor] = useState<string>('');

 


    useEffect(() => {
    if (fechaInicio && fechaFin) {
      generarReporte();
    }
  }, [triggerBusqueda, fechaInicio, fechaFin]);

  const generarReporte = () => {
    let errorMessages: string[] = [];

    // 5. Usamos las props fechaInicio y fechaFin en lugar de estados locales
    RelojChecador.getEntradasSalidasFechas(fechaInicio, fechaFin)
      .then((response) => {
        setData(response.data);
        setFilteredData(response.data);
        setToastMsg('Información de resumen encontrada');
        setToastHeader('Informativo');
        setToastColor('success');
        setShowToast(true);
      })
      .catch(() => errorMessages.push('Error en resumen'));

    RelojChecador.getReporteChecadas(fechaInicio, fechaFin)
      .then((response) => {
        setDetalleData(response.data);
      })
      .catch(() => errorMessages.push('Error en detalle'));

    if (errorMessages.length > 0) {
      setToastMsg(errorMessages.join(' | '));
      setToastHeader('Error');
      setToastColor('danger');
      setShowToast(true);
    }
  };




  function currentDate(): string {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();
    return `${yyyy}-${mm}-${dd}`;
  }

 





  const columns = [

    {
      name : 'ID', 
      width: '120px', 
      selector: (row: DTOReporteFechas) => row.userId, 
      filter: true
    }, 
    {
      name: 'No. Empleado',
      width: '120px',
      selector: (row: DTOReporteFechas) => row.numeroEmpleado,
      sortable: true,
      filter: true,
    },
    {
      name: 'Nombre',
      width: '200px',
      selector: (row: DTOReporteFechas) => row.nombreEmpleado,
      sortable: true,
      filter: true,
    },

    {
      name: 'Departamento',
      width: '200px',
      selector: (row: DTOReporteFechas) => row.departamento,
      sortable: true,
      filter: true,
    },

    {
      name: 'Oficina',
      width: '200px',
      selector: (row: DTOReporteFechas) => row.oficina,
      sortable: true,
      filter: true,
      
    },

    {
      name: 'HoraEntrada',
      width: '200px',
      selector: (row: DTOReporteFechas) => row.horaEntrada,
      sortable: true,
      filter: true,
    },
    {
      name: 'Total Horas',
      width: '120px',
      selector: (row: DTOReporteFechas) => row.totalHoras,
      sortable: true,
      filter: true,
    },
    {
      name: 'Horas Extras',
      width: '120px',
      selector: (row: DTOReporteFechas) => row.horasExtras,
      sortable: true,
      filter: true,
    },
    {
      name: 'Retardos',
      width: '120px',
      selector: (row: DTOReporteFechas) => row.totalRetardos,
      sortable: true,
      filter: true,
    },
    
    {
      name: 'Faltas',
      width: '120px',
      selector: (row: DTOReporteFechas) => row.totalFaltas,
      sortable: true,
      filter: true,
    },
    
    
  ];

  const filtraReporte = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchText = e.target.value.toLowerCase();
    setFiltro(searchText);

    const filtered = data.filter((item) =>
      item.numeroEmpleado.toLowerCase().includes(searchText) ||
      item.nombreEmpleado.toLowerCase().includes(searchText) 
    );
    setFilteredData(filtered);
  };

  

  const exportExcel = () => {
    const wb = XLSX.utils.book_new();

    // Hoja de Resumen
    const headingResumen = [
      ['ID', 'Nombre', 'NumEmpleado', 'Departamento', 'Oficina',   'Hora Entrada', 'Total Horas', 'Horas Extras', 'Retardos', 'Faltas'],
    ];
    const wsResumen: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_aoa(wsResumen, headingResumen);
    XLSX.utils.sheet_add_json(wsResumen, filteredData, { origin: 'A2', skipHeader: true });

    // Hoja de Detalle
    const headingDetalle = [
      ['ID', 'NumEmpleado', 'Nombre', 'Fecha', 'Entrada 1', 'Salida 1', 'Entrada 2', 'Salida 2', 'Entrada 3', 'Salida 3', 'Total Horas'],
    ];
    // Usar las fechas y horas en el formato de la plataforma (YYYY-MM-DD y HH:mm:ss)
    const formattedDetalleData = detalleData.map((item) => ({
      userId: item.userId,
      numeroEmpleado: item.numeroEmpleado,
      nombreEmpleado: item.nombreEmpleado,
      fecha: item.fecha, // Asumiendo que viene como YYYY-MM-DD
      entrada1: item.entrada1 || '',
      salida1: item.salida1 || '',
      entrada2: item.entrada2 || '',
      salida2: item.salida2 || '',
      entrada3: item.entrada3 || '',
      salida3: item.salida3 || '',
      totalHoras: item.totalHoras,
    }));

    const wsDetalle: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_aoa(wsDetalle, headingDetalle);
    XLSX.utils.sheet_add_json(wsDetalle, formattedDetalleData, { origin: 'A2', skipHeader: true });

    // Capitalizar encabezados en ambas hojas
    const capitalizeHeaders = (ws: XLSX.WorkSheet) => {
      const range = XLSX.utils.decode_range(ws['!ref']!);
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const address = XLSX.utils.encode_col(C) + '1';
        if (ws[address]) ws[address].v = ws[address].v.toUpperCase();
      }
    };

    capitalizeHeaders(wsResumen);
    capitalizeHeaders(wsDetalle);

    // Agregar hojas al libro
    XLSX.utils.book_append_sheet(wb, wsResumen, 'Resumen');
    XLSX.utils.book_append_sheet(wb, wsDetalle, 'Detalle');

    // Generar archivo Excel
    XLSX.writeFile(wb, 'ReporteSemanal.xlsx');
  };



  return (
    <div className="mt-2">
      <Card>
        <Card.Body>
          <Form>
            <Row className="align-items-center">
              <Col xs={2}>
                <Form.Label>Desde</Form.Label>
                <Form.Control
                  type="date"
                  value={inicio}
                  onChange={(e) => setInicio(e.target.value)}
                  size="sm"
                />
              </Col>
              <Col xs={2}>
                <Form.Label>Hasta</Form.Label>
                <Form.Control
                  type="date"
                  value={fin}
                  onChange={(e) => setFin(e.target.value)}
                  size="sm"
                />
              </Col>
              <Col xs={3}>
                <Form.Control
                  type="text"
                  placeholder="Buscar por No. Empleado o Nombre..."
                  onChange={filtraReporte}
                  size="sm"
                />
              </Col>
              <Col xs={2}>
                <Button variant="success" onClick={exportExcel} size="sm">
                  <BsFileEarmarkExcel /> Excel
                </Button>
              </Col>
              <Col xs={2}>
                <Button variant="primary" onClick={generarReporte} size="sm">
                  <BsSearch /> Buscar
                </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>

      <MsgInformativo
        show={showToast}
        msg={toastMsg}
        header={toastHeader}
        msgColor={toastColor}
        closeToast={() => setShowToast(false)}
      />

      <Card className="mt-3">
        <Card.Body>
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
   
            paginationPerPage={10}
            striped
            highlightOnHover
            dense
            noHeader
          />
        </Card.Body>
      </Card>
    </div>
  );
}